import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useAdminExamPurchases } from "../../../store/admin";
import {
  formatDate,
  formatAmountForDisplay,
  paymentStatusBadgeClass,
  fulfillmentStatusBadgeClass,
  emailStatusBadgeClass,
} from "./examUtils";

// Renders a single purchase fetched via GET /api/admin/exam-purchases/:id
const ExamPurchaseDetailModal = ({ isOpen, onClose, purchaseId, onRetry, retryLoading }) => {
  const {
    examPurchaseDetail = null,
    examPurchaseDetailLoading,
    fetchExamPurchaseById,
  } = useAdminExamPurchases();

  useEffect(() => {
    if (isOpen && purchaseId) {
      fetchExamPurchaseById(purchaseId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, purchaseId]);

  const d = examPurchaseDetail;

  const rows = d
    ? [
        ["Reference", d.reference || "--"],
        ["Customer", d.customerName || d.name || "—"],
        ["Email", d.customerEmail || "—"],
        ["Phone", d.phone || "—"],
        ["Amount", `₦${formatAmountForDisplay(d.amount)}`],
        ["Payment Status", d.paymentStatus],
        ["Fulfillment Status", d.fulfillmentStatus],
        ["Email Status", d.emailStatus || "--"],
        ["Exam Type", d.examType || "—"],
        ["Date", formatDate(d.createdAt)],
        ["Last Updated", formatDate(d.updatedAt)],
      ]
    : [];

  const statusBadge = (label, value, fn) =>
    label === "Payment Status" ? (
      <span className={paymentStatusBadgeClass(value)}>{value}</span>
    ) : label === "Fulfillment Status" ? (
      <span className={fulfillmentStatusBadgeClass(value)}>{value}</span>
    ) : label === "Email Status" ? (
      <span className={emailStatusBadgeClass(value)}>{value}</span>
    ) : (
      value
    );

  return (
    <Modal show={isOpen} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Exam Purchase Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {examPurchaseDetailLoading && !d ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : !d ? (
          <p className="mb-0 text-center text-slate-500">No purchase found.</p>
        ) : (
          <>
            <table className="table table-sm align-middle">
              <tbody>
                {rows.map(([label, value]) => (
                  <tr key={label}>
                    <td className="fw-medium text-slate-600" style={{ width: "200px" }}>
                      {label}
                    </td>
                    <td>
                      {statusBadge(label, value) || (
                        <span className={""}>{statusBadge(label, value)}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              className="btn btn-primary"
              onClick={() => onRetry(d)}
              disabled={retryLoading || d.fulfillmentStatus !== "INVENTORY_SHORTAGE"}
              title={
                d.fulfillmentStatus === "INVENTORY_SHORTAGE"
                  ? "Retry fulfillment"
                  : "Only purchases awaiting inventory can be retried"
              }
            >
              <FontAwesomeIcon
                icon={faRotateRight}
                spin={retryLoading}
                className="me-1"
              />
              {retryLoading ? "Retrying..." : "Retry Fulfillment"}
            </button>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExamPurchaseDetailModal;